import type { RouteCallback } from '@faceup/router'

export const getPageRouteCallback =
  (page: { id: string } | null | undefined): RouteCallback =>
  routes =>
    routes.page({ id: page?.id })

export const isFromAkutan = (url: string | null | undefined) => {
  if (!url) {
    return false
  }

  try {
    const referrerOrigin = new URL(url).origin
    return referrerOrigin === import.meta.env.VITE_AKUTAN_URL
  } catch {
    return false
  }
}

export const isAkutanPreview = () => isFromAkutan(document.referrer)
